var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Delivery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9767 7.78522L10.9678 7.74514L10.9558 7.70591L9.35396 2.5H10.5696C12.3984 4.48008 13.3809 6.4683 13.908 7.97567C14.1794 8.75192 14.3298 9.40015 14.4121 9.85248C14.8504 10.0867 15.2237 10.4266 15.498 10.8381C15.5035 10.7258 15.5063 10.6101 15.5063 10.4912C15.5063 10.4912 15.2635 5.9 11 1.5H9.04627H8L8.30769 2.5L10 8C10.2207 9.00351 10 9.5 9.5 9.5H8C7.5 9.5 7.12041 6.72807 7.12041 6.47719C7.12041 6.22632 6.89973 5.97544 6.67905 5.97544H3.36884C1.16204 5.97544 0.5 11.9965 0.5 12.4982C0.5 12.7491 0.70557 13 0.941361 13H10.0415C10.0142 12.8374 10 12.6704 10 12.5C10 12.3296 10.0142 12.1626 10.0415 12H1.54733C1.56714 11.8332 1.59333 11.6363 1.62656 11.4177C1.71905 10.8094 1.86322 10.0524 2.06946 9.31964C2.27958 8.57318 2.53635 7.91734 2.82777 7.46946C3.1343 6.99838 3.32682 6.97544 3.36884 6.97544H6.16665C6.17647 7.04997 6.1872 7.12622 6.19817 7.20082C6.24401 7.51256 6.31089 7.90561 6.39551 8.29502C6.47787 8.67405 6.5862 9.09323 6.72362 9.43552C6.79004 9.60097 6.88558 9.80614 7.02377 9.98717C7.1352 10.1331 7.45486 10.5 8 10.5H9.5C9.7946 10.5 10.1141 10.4246 10.3994 10.2218C10.6837 10.0198 10.8606 9.74354 10.9609 9.46585C11.147 8.95019 11.101 8.35076 10.9767 7.78522Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14.5C14.1046 14.5 15 13.6046 15 12.5C15 11.3954 14.1046 10.5 13 10.5C11.8954 10.5 11 11.3954 11 12.5C11 13.6046 11.8954 14.5 13 14.5ZM16 12.5C16 14.1569 14.6569 15.5 13 15.5C11.3431 15.5 10 14.1569 10 12.5C10 10.8431 11.3431 9.5 13 9.5C14.6569 9.5 16 10.8431 16 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54148 12C1.5142 12.1626 1.5 12.3296 1.5 12.5C1.5 14.1569 2.84315 15.5 4.5 15.5C6.15685 15.5 7.5 14.1569 7.5 12.5C7.5 12.3296 7.4858 12.1626 7.45852 12H6.43699C6.47812 12.1598 6.5 12.3274 6.5 12.5C6.5 13.6046 5.60457 14.5 4.5 14.5C3.39543 14.5 2.5 13.6046 2.5 12.5C2.5 12.3274 2.52188 12.1598 2.56301 12H1.54148Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 2C5.5 1.72386 5.72386 1.5 6 1.5H13.5C13.7761 1.5 14 1.72386 14 2C14 2.27614 13.7761 2.5 13.5 2.5H6C5.72386 2.5 5.5 2.27614 5.5 2Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.ee373917fdced305d34773cd5ea67e3f.svg";
export { ForwardRef as ReactComponent };